import { combineReducers } from 'redux'
import { reducer as publicEmbed } from 'lib/api/embeds/regional'

export const rootReducer = combineReducers({
  publicEmbed
})
